// Known aliases: DB system name (normalized) → Glue job name (normalized)
const JOB_NAME_ALIASES: Record<string, string> = {
    'sapsuccessfactors': 'successfactors',
    'bobhr': 'hibob',
}

// Normalize separators (hyphens, underscores, spaces) so "david-shield", "david_shield",
// and "david shield" all compare equal — entity names and system names vary across DBs and Glue.
const normSep = (s: string) => s.toLowerCase().replace(/[-_\s]/g, '')

export interface ScheduledGlueJob {
    job_name: string
    aws_region: string
}

/** Find the actual jobs for an entity/system using the trigger's matching rules. */
export function getSystemScheduledJobs(entityName: string, systemName: string, systemAbbr: string | undefined, schedules: any[]): ScheduledGlueJob[] {
    const jobs = new Map<string, ScheduledGlueJob>()
    const entityNorm = normSep(entityName)
    const candidates = [systemName.toLowerCase()]
    if (systemAbbr) candidates.push(systemAbbr.toLowerCase())

    for (const schedule of schedules) {
        for (const jobAction of (schedule.job_actions || [])) {
            const args = jobAction.arguments || {}
            const jobEntityRaw = args['--entity_name'] || args['--entity_system'] || ''
            if (normSep(jobEntityRaw) !== entityNorm) continue

            const hasSystemArg = !!args['--system_name']
            if (hasSystemArg) {
                // Generic ETL: --system_name is explicit; normalize separators before comparing
                const jobSystem = normSep(args['--system_name'])
                if (candidates.some(c => normSep(c) === jobSystem)) {
                    jobs.set(`${schedule.aws_region}:${jobAction.job_name}`, { job_name: jobAction.job_name, aws_region: schedule.aws_region })
                }
            } else {
                // Non-generic ETL: job name IS the system (e.g., "successfactors2s3-high-performance")
                // Strip "-high-performance" and "2s3" suffixes, normalize all separators, compare exactly
                const jobName = normSep((jobAction.job_name || '').replace(/-high-performance$/, '').replace(/2s3$/, ''))
                if (candidates.some(c => {
                    const cNorm = normSep(c)
                    const resolved = JOB_NAME_ALIASES[cNorm] || cNorm
                    return resolved === jobName
                })) {
                    jobs.set(`${schedule.aws_region}:${jobAction.job_name}`, { job_name: jobAction.job_name, aws_region: schedule.aws_region })
                }
            }
        }
    }
    return Array.from(jobs.values())
}

export function systemHasSchedule(entityName: string, systemName: string, systemAbbr: string | undefined, schedules: any[]): boolean {
    return getSystemScheduledJobs(entityName, systemName, systemAbbr, schedules).length > 0
}
